module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":{"both":"There were no results matching your search/filter criteria.","filter":"You have no {filter} landing pages","search":"Your search for \\"{search}\\" returned no results"},"description":{"both":"Try adjusting your search query or filters","filter":"Try changing your filter settings","search":"Try searching for something else"}}}')
  delete Component.options._Ctor
}
